import { RequestDataSetting } from 'api/chat/setting/update-setting';
import React from 'react';

interface IGeneralProps {
  self: RequestDataSetting;
}

function General({ self }: IGeneralProps) {
  // const [messageSetting, setMessageSetting] = useState({
  //   limit_number_of_conversation: self.limit_number_of_conversation,
  // });

  const handleChangeLanguage = (e) => {
    console.log(e.target.value, self.limit_number_of_conversation);
  };

  return (
    <div className='general-chat'>
      <div className='tab-item'>
        <div className='list-group-item h-d_flex'>
          Language
          <span>
            <select className='custom-select' defaultValue={0} onChange={handleChangeLanguage}>
              <option value='0'>Vietnamese</option>
              <option value='1'>China</option>
              <option value='2'>South Korea</option>
              <option value='3'>Japan</option>
            </select>
          </span>
        </div>
      </div>
      <div className='tab-item'>
        <div className='list-group-item h-d_flex list-two'>
          Limited number of conversations
          <span>
            <select className='custom-select' defaultValue={1}>
              <option value='0'>1</option>
              <option value='1'>5</option>
              <option value='2'>10</option>
              <option value='3'>15</option>
            </select>
          </span>
        </div>
      </div>
    </div>
  );
}

export default General;
